import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import CenterFocusStrongIcon from "@mui/icons-material/CenterFocusStrong";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { useEffect, useState } from "react";
import {
  PmxActivity,
  RepositoryObjectFolder,
  RepositoryTree
} from "../../backend/types";
import { StyledTreeItem, renderTreeNodes } from "../../helpers/treeHelper";
import { extractTreeViewArrayFromURL } from "../../helpers/urlHelper";

const DELIMITER = "__-*-__";
export function TreeViewListFilesInRepo(props: {
  foldersAndCount: RepositoryObjectFolder[];
  repositoryTree: RepositoryTree;
  activityData: PmxActivity;
  onNodeSelect: Function;
  currentSelectedPath: string;
  currentSelectedRepoId: string;
}) {
  useEffect(() => {
    document
      .querySelectorAll(".MuiTreeItem-root")
      .forEach((e) => e.removeAttribute("tabindex"));
  }, [props]);

  const [expanded, setExpanded] = useState(["/"]);
  const [selected, setSelected] = useState(["/"]);

  const handleSelect = (event: any, value: any) => {
    setSelected(value);

    event.persist();
    const iconClicked = event.target.closest(".MuiTreeItem-iconContainer");
    if (!iconClicked) {
      let actualValue;
      if (value.includes(DELIMITER)) {
        actualValue = value.split(DELIMITER)[1];
      } else {
        actualValue = value;
      }
      setSelected(value);
      props.onNodeSelect({
        path: actualValue,
        versionId: event.target.getAttribute("data-versionid") || null,
        revision: event.target.getAttribute("data-revision") || null,
        repoId: props.repositoryTree.repository.id
      });
    }
  };

  // This allows expansion of the tree from tree, table, and url path.
  useEffect(() => {
    if (props.currentSelectedPath && props.currentSelectedPath !== "") {
      const actualValue =
        props.currentSelectedRepoId +
        DELIMITER +
        String(props.currentSelectedPath);
      setExpanded((prevExpanded) => [
        ...prevExpanded,
        ...extractTreeViewArrayFromURL(actualValue)
      ]);
      setSelected([actualValue]);
    } else {
      setExpanded(["/"]);
      setSelected(["/"]);
    }
  }, [props.currentSelectedPath, props.repositoryTree]);

  //only expand if icon was clicked
  const handleToggle = (event: any, nodeIds: any) => {
    event.persist();
    const iconClicked = event.target.closest(".MuiTreeItem-iconContainer");
    const labelClicked = iconClicked
      ?.querySelector("svg")
      ?.getAttribute("data-testid");

    // we load the content of the folder if the "plus" icon was clicked
    if (iconClicked && labelClicked === "AddBoxOutlinedIcon") {
      const treeItem =
        iconClicked.parentElement?.querySelector(".MuiTreeItem-label")
          ?.firstElementChild;
      if (treeItem) {
        const absolutePath = treeItem.getAttribute("data-absolutepath"); // TO-DO: Move these to constants
        if (absolutePath) {
          props.onNodeSelect({
            path: absolutePath,
            versionId: treeItem.getAttribute("data-versionid"),
            revision: event.target.getAttribute("data-revision") || null,
            repoId: props.repositoryTree.repository.id
          });
        }
      }
    }

    if (iconClicked) {
      setExpanded(nodeIds);
    }
  };

  return (
    <>
      <SimpleTreeView
        slots={{
          expandIcon: AddBoxOutlinedIcon,
          collapseIcon: IndeterminateCheckBoxOutlinedIcon
        }}
        onSelectedItemsChange={handleSelect}
        onExpandedItemsChange={handleToggle}
        defaultExpandedItems={["/"]}
        expandedItems={expanded}
        selectedItems={selected}
        className={[
          `mt-2 tree-view`,
          `${
            props.repositoryTree.repository.id !==
            props.activityData.mainRepository.id
              ? "opacity-60"
              : ""
          }`
        ].join(" ")}
      >
        <StyledTreeItem
          key={"/"}
          itemId={"/"}
          label={
            <>
              <CenterFocusStrongIcon className="grey_color" />{" "}
              {props.repositoryTree.repository.name}
            </>
          }
        >
          {renderTreeNodes(
            props.repositoryTree.repositoryObjects,
            props.repositoryTree.repository.id,
            props.foldersAndCount,
            props.onNodeSelect
          )}
        </StyledTreeItem>
      </SimpleTreeView>
    </>
  );
}
